import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

function TypesOfRadios({ data }) {

  const {area_name, area_name_full} = data

  const images = useStaticQuery(graphql`
      query {
          portableTwoWay: file(relativePath: {eq: "commusa-portable-two-way-radios.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          mobileRadios: file(relativePath: {eq: "commusa-mobile-radios.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          baseStations: file(relativePath: {eq: "commusa-base-stations.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          repeaters: file(relativePath: {eq: "commusa-repeaters.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
            radioOverIp: file(relativePath: {eq: "commusa-radio-over-ip.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
      }
  `)

  return (
    <div className="container py-3">
      <div className="row">
        <div className="col-12 mt-4">
          <h3>Types of Two-Way Radios for Sale in {area_name}</h3>
          <p>With a two-way radio system from CommUSA, you’re getting a safe, cost-effective, and completely customized
            way to communicate with your team.</p>
          <p>Many of our two-way radio models are deemed intrinsically safe, with completely spark-proof interiors and
            exteriors for ultimate peace of mind. Plus, our two-way radios don’t rely on cell towers. So if disaster
            strikes, you won’t miss a beat.</p>
          <p>CommUSA doesn’t think one two-way radio model fits all either. That’s why we carry portables, mobiles, and
            base stations of varying sizes, capabilities, and price levels. Whether you work in the industrial sector or
            a
            standalone retail store, CommUSA has a two-way radio solution for your unique needs.</p>
        </div>
        <div className="col-12">
          <div className="row mt-4">
            <div className="col-12 col-md-4"><Img className="w-100" fluid={images.portableTwoWay.childImageSharp.fluid}
                                                  alt="CommUSA - Portable Two-Way Radios"/></div>
            <div className="col-12 col-md-8">
              <h5>Mobile Two-Way Radios</h5>
              <p>Mobile two-way radios are ideal communication solutions for professionals who work in fixed locations.
                Whether that’s your vehicle or your office, a mobile two-way radio offers the benefits of a constant
                power
                source and extended range.</p>
              <p>CommUSA mobile two-way radios consist of the mobile radio itself, plus vehicle mounting brackets,
                battery
                power cables and palm style microphones. We also carry a variety of vehicle and building style antennas
                to
                extend the range of your mobile even further.</p>
              <p>We also offer fleet vehicle installation for our mobile radios and installation services for our base
                stations. That’s why school bus systems, city engineers, and public works departments
                in {area_name_full} prefer to source all their mobile two-way radio and base station needs from
                CommUSA.</p>
              <div className="btn-group" role="group">
                <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                  className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                            href="https://www.commusa.com/contact-us">Request
                Quote</a>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 col-md-4"><Img className="w-100" fluid={images.mobileRadios.childImageSharp.fluid}
                                                  alt="CommUSA - Mobile Two-Way Radios"/></div>
            <div className="col-12 col-md-8">
              <h5>Portable Two-Way Radios</h5>
              <p>If your workers aren’t chained to a desk or vehicle, they need more than what a mobile two-way radio
                can
                offer. That’s where portable two-way radios come in.</p>
              <p>Portables are convenient handheld two-way radio devices that you can clip to your belt when not in use.
                Depending on your working conditions, CommUSA has compact two-way radio models, heavy-duty two-way radio
                models, and everything in between.</p>
              <p>Perfect for hospitals, casinos, oil and gas companies, amusement parks, and more, a portable two-way
                radio system from CommUSA is the affordable and reliable communication solution you need for your next
                big
                project.</p>
              <div className="btn-group" role="group">
                <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                  className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                            href="https://www.commusa.com/contact-us">Request
                Quote</a>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 col-md-4 justify-content-start justify-content-md-center"><Img className="w-100"
                                                                                                  fluid={images.baseStations.childImageSharp.fluid}
                                                                                                  alt="CommUSA - Two-Way Radio Base Stations"/>
            </div>
            <div className="col-12 col-md-8">
              <h5>Base Stations</h5>
              <p>With a base station from CommUSA, your mobile two-way radio will always be ready to go when
                communication
                is most critical. We can convert your mobile radio into a base station by adding a desktop power supply,
                desktop microphone and external antenna.&nbsp; Your mobile radio stays plugged into the power supply for
                all-day operations and you won’t have to worry about it walking away from the desk.</p>
              <p>Hook up your base station to a dispatch console and get seamless individual-to-group or group-to-group
                communication.</p>
              <p>You’ll also get up to 8% extra coverage in dead spots, perfect for even the most rural jobs. If that’s
                not enough, CommUSA carries base station-compatible MOTOTRBO repeaters for your extended coverage
                needs.</p>
              <div className="btn-group" role="group">
                <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                  className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                            href="https://www.commusa.com/contact-us">Request
                Quote</a>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 col-md-4"><Img className="w-100" fluid={images.repeaters.childImageSharp.fluid}
                                                  alt="CommUSA - Two-Way Radio Repeaters"/></div>
            <div className="col-12 col-md-8">
              <h5>Repeaters</h5>
              <p>Portable, mobile and base station two-way radios can only talk so far. We’ve all seen the two-way radio
                advertisements that boast of “up to 35 mile range,” but the truth is obstructions in the path of your
                radio signal like buildings, walls, furniture or even trees, hills or mountains if you are outdoors, can
                degrade your transmission signal significantly. If you are in a skyrise building, depending on the
                construction materials of the building, you may only get 7 to 10 floors with a full power business
                radio.
                And if you add to that same building things like underground floors or parking structures with thick
                concrete separations, your coverage may even be worse. On a large outdoor campus like a business park or
                University, you may only get a quarter mile of coverage.</p>
              <p>Every environment is different and we have the expert communications consultants to help you find the
                right solution. Repeaters are one of those options in that they “repeat” the signal of your two-way
                radio
                portable, mobile, or base station, at a higher power and with a better antenna that is designed to fill
                in
                the gaps of your coverage area. If it’s determined that you can’t cover your area without a Repeater,
                then
                we’ll help you choose the right custom set up.</p>
              <p>We sell many Motorola Repeaters, including the SLR1000, SLR5700, MTR3000 and SLR8000. All of our
                Repeaters from Motorola are unique and custom configured for your needs. Best of all, we even offer
                Repeater solutions to connect multiple properties using Radio Over IP technology with solutions by
                Motorola such as IP Site Connect, Multi-Site Capacity Plus, Connect Plus and Capacity Max.</p>
              <div className="btn-group" role="group">
                <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                  className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                            href="https://www.commusa.com/contact-us">Request
                Quote</a>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 col-md-4"><Img className="w-100" fluid={images.radioOverIp.childImageSharp.fluid}
                                                  alt="CommUSA - Radio Over IP"/></div>
            <div className="col-12 col-md-8">
              <h5>Radio Over IP</h5>
              <p>Have multiple sites you need to communicate across in {area_name_full}? CommUSA has you covered with
                our
                radio over IP site connections.</p>
              <p>These robust solutions work by placing repeaters at each of your job sites. Then, we use an IP to
                connect
                the repeaters seamlessly, allowing you to communicate across anywhere from 5 to 250 different
                locations.</p>
              <div className="btn-group" role="group">
                <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                  className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                            href="https://www.commusa.com/contact-us">Request
                Quote</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TypesOfRadios
